
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    ORTDRIVING_ACTION,
    ALL_ORTDRIVING,
    ADD_ORTDRIVING,
    FETCH_ORTDRIVING,
    EDIT_ORTDRIVING,
    DELETE_ORTDRIVING,
    FETCH_ORTDRIVINGCHART,
    FETCH_ORTDRIVINGSHOTCHART,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * On Range Driving Test Actions
 */

    export const allORTDrivingTest = () =>{    
        
        return (dispatch) => { 
            dispatch({ type: ORTDRIVING_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getonrdriving', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_ORTDRIVING, payload: alldata });
            });
        }        

    }

    export const studentORTDrivingTest = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:ORTDRIVING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentonrdriving', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data.data;
                dispatch({ type: ALL_ORTDRIVING, payload: alldata }); 
            });
        
        }
    }

    export const addORTDrivingTest = (data, sepmore) =>{
        var stdid=data.target.student.value;
        var payload={
            "totval":1,
            "student_1":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
        }

        for (let i = 0; i<sepmore; i++) {        
            
            var shot='club_'+i;            
            var shotval=data.target[shot].value;
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;            
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            
            var fair='fairway_'+i;            
            var fairval=data.target[fair].value;
            var process='process_'+i;            
            var processval=data.target[process].value;
                
            
            var adval=i+1;
            var shotadd='club_1_'+adval;
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var fairadd='fairway_1_'+adval;  
            var contadd='contact_1_'+adval;  
            var processadd='process_1_'+adval;
            
            payload[shotadd]=shotval;
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[fairadd]=fairval;
            payload[contadd]=contactval;           
            payload[processadd]=processval;            
    
        }        

        return (dispatch) => { 
            dispatch({ type:ORTDRIVING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addonrdriving', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTDrivingTest(stdid, start, end)(dispatch);
                    var club='';
                    var area='';
                    var contact='';
                    fetchORTDrivingReport(stdid, start, end, club, area, contact)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_ORTDRIVING});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchORTDrivingTest = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }
        return (dispatch) => { 
            dispatch({ type:ORTDRIVING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getonrdrivingdetails', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_ORTDRIVING, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editORTDrivingTest = (data, sepmore, oldate) =>{
        var stdid=data.target.student.value;
        var payload={
            "totval":1,
            "student":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
            "olddate":oldate,
        }

        for (let i = 0; i<sepmore; i++) {        
            
            var shot='club_'+i;            
            var shotval=data.target[shot].value;
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;            
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            
            var fair='fairway_'+i;            
            var fairval=data.target[fair].value;
            var process='process_'+i;            
            var processval=data.target[process].value;
                
            
            var adval=i+1;
            var shotadd='club_1_'+adval;
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var fairadd='fairway_1_'+adval;  
            var contadd='contact_1_'+adval;  
            var processadd='process_1_'+adval;
            
            payload[shotadd]=shotval;
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[fairadd]=fairval;
            payload[contadd]=contactval;           
            payload[processadd]=processval;            
    
        } 

        return (dispatch) => { 
            dispatch({ type:ORTDRIVING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editonrdriving', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTDrivingTest(stdid, start, end)(dispatch);
                    var club='';
                    var area='';
                    var contact='';
                    fetchORTDrivingReport(stdid, start, end, club, area, contact)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_ORTDRIVING});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const deleteORTDrivingTest = (id, date) =>{
        
        var payload={
            "id":id,
            "date":date
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTDRIVING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleteonrdriving', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTDrivingTest(id, start, end)(dispatch);
                    var club='';
                    var area='';
                    var contact='';
                    fetchORTDrivingReport(id, start, end, club, area, contact)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_ORTDRIVING});                    
                }                
                
            });
        
        }
    }

    export const fetchORTDrivingReport = (id, start, end, club, area, contact) =>{
        
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "club":club,
            "contact":contact,
            "area":area,         
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTDRIVING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onrangedrivingreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_ORTDRIVINGCHART, payload: resdata});                 
                return Promise.resolve(resdata);  
            });
        
        }
    }

    export const fetchORTDrivingShotChart = (id, start, end, club, area, contact, val) =>{
        
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "club":club,
            "contact":contact,
            "area":area,
            "section":val            
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTDRIVING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onrangedrivingshotchart', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_ORTDRIVINGSHOTCHART, payload: resdata});                 
                return Promise.resolve(resdata);
            });
        
        }
    }

